export default __webpack_public_path__ + "static/media/division-1.28cb1442.png";